var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoAlmaBlack = function SvgLogoAlmaBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.78659L0.00210158 0L15.8123 0.0299572L15.8648 15.0805L0 15.0785L0.0231173 5.63994L11.9117 5.66191L11.8823 3.75464L0 3.78659ZM11.9054 11.3118L11.9075 9.3826L3.97195 9.40657L3.98456 11.3059L11.9054 11.3118Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7785 20.706V16.9194L33.5886 16.9494L33.6412 31.9999L17.7764 31.9979L17.8016 22.5594L29.6865 22.5814L29.6571 20.6741L17.7785 20.706ZM29.6802 28.2313L29.6844 26.302L21.7499 26.328L21.7625 28.2253L29.6802 28.2313Z",
    fill: "#4A4A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7669 0.00535503L21.7939 11.3092L33.6412 11.3089L33.6335 15.076L17.7829 15.0805L17.7764 0L21.7669 0.00535503Z",
    fill: "#4A4A4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8648 16.9194L15.8382 31.977L11.922 31.9999L11.8571 20.6483H9.96044L9.91038 31.9999H5.93762L5.95713 20.6483H4.02383L3.99722 31.9999H0.0155369L0 16.9287L15.8648 16.9194Z",
    fill: "#4A4A4A"
  })));
};
export default SvgLogoAlmaBlack;